import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./reset.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { Router } from "./router";
import Fixed from "./components/linksSocialFixed/index";
import Header from "./components/Header/index";
//import TrackPageView from "./pages/testes/components/PageView";
import ReactPixel from "react-facebook-pixel";
import GA4React from "ga-4-react";
import TagManager from "react-gtm-module";
import AOS from 'aos';
import 'aos/dist/aos.css';
ReactPixel.init("809503810598473", {});

function Manager() {
  useEffect(() => {
    TagManager.initialize({ gtmId: "GTM-PSPFRSN" });
  }, []);
}

AOS.refresh();
AOS.init({
  offset: 200,
  duration: 1000,
  easing: "ease-in-sine",
  once: true,
});

function FacebookPixel() {
  React.useEffect(() => {
    import("react-facebook-pixel")
      .then((x) => x.default)
      .then((ReactPixel) => {
        ReactPixel.init("809503810598473");
        ReactPixel.pageView();

        Router.events.on("routeChangeComplete", () => {
          ReactPixel.pageView();
        });
      });
  });
  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <FacebookPixel />
        <Manager />
        {/* <TrackPageView /> */}
        <Header />
        <Fixed />
        <Router />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

try {
  setTimeout((_) => {
    const ga4react = new GA4React("G-5Y075YFGMZ");
    ga4react.initialize().catch((err) => console.error(err));
  }, 4000);
} catch (err) {
  console.error(err);
}
